/***
 * Created on 2023/7/17
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/


import React from 'react';
import TableHeader from "./table_header";

function Table({fieldNameList, currentSortType, setCurrentSortType, sortDirection, setSortDirection, children}) {
    return (
        <div className="comp-flex-table" data-has-pagination={true}>
            <div className="flex-table-wrapper">
                <TableHeader fieldNameList={fieldNameList} currentSortType={currentSortType} setCurrentSortType={setCurrentSortType} sortDirection={sortDirection} setSortDirection={setSortDirection}/>
                <div className="flex-table-body" style={{"overflow": "auto"}}>{children}</div>
            </div>
        </div>
    );
}

export default Table;